import React, { useState, memo, useEffect } from 'react';
import { Box, FsButton ,FsAutocomplete, fsTheme} from '@aviatrix/flights';
import {IconAWSMarketplace, IconAzure, IconGoogle} from '../SVGIcons';

export type CSP = 'AWS' | 'Azure' | 'GCP';

type CloudTypeSelectorProps = {
    csp:Array<CSP>,
    callback:(selectCSP:CSP,option:string|undefined)=>void
}

export type CSPDefinition = {
    csp:CSP,
    options?:string[]
}
const CSPList:Array<CSPDefinition> = [
    {csp:'AWS', options:['Standard']},
    {csp:'Azure', options:['Standard']},
    {csp:'GCP'},
];

export type CloudTypeStateProps = {
    csp:CSP,
    option?:string | undefined
}
 

const CloudTypeSelector = ({csp ,callback}:CloudTypeSelectorProps)=>{    
    
    const [CurrentSelection,setCurrentSelection] = useState<CloudTypeStateProps>();
    const handlerSelect = (param: CloudTypeStateProps )=>{
        setCurrentSelection(param);
        callback(param.csp, param.option);
    }
    
    const style_button = {
        '&.active':{
            border:`1px solid ${fsTheme.light.border}!important`,
            boxShadow: `inset 0 0 6px ${fsTheme.light.primary.main}`
        },
        borderRadius:3,
        borderColor:`${ fsTheme.light.border.main } !important`, 
        padding:'25px 15px 25px 14px!important',
        '& .dropdown':{
            marginLeft:'10px',
            minWidth:'90px'
        },
        '& .dropdown.disabled .MuiInputBase-root ':{
            background:`${ fsTheme.light.border.light }`
        },
        '& img':{
            width:'24px',
            height:'24px',
        } 
    }
    
    const getIcon = (csp:CSP)=>{
        if(csp == 'AWS') return IconAWSMarketplace;
        else if(csp == 'Azure') return IconAzure;
        else if(csp == 'GCP') return IconGoogle;
    }
    
    useEffect(()=>{
        // set default value
        if(csp){
            let default_option = '';
            const first_csp_name = csp[0];
            const first_csp = CSPList.filter(item=> item.csp.indexOf(first_csp_name) !=-1 );
            if(first_csp){
                //console.log(first_csp[0].options?.length)
                if(first_csp[0].options?.length){       
                    default_option = first_csp[0].options[0];
                }
            }
            callback(first_csp_name, default_option);
            setCurrentSelection({csp:first_csp_name,option:default_option});
        }
    },[])

    let filterCSP:Array<CSPDefinition> = [];
    filterCSP = CSPList.filter(item=> csp.indexOf(item.csp) !=-1 );
    
    return(
        <Box display="flex" flexDirection="row"  gap={1} width="100%" paddingBottom={1}>
            {filterCSP && filterCSP.map((item:CSPDefinition,index:number) =>(
                
                <FsButton variant='outlined' key={index}
                    sx={style_button}
                    className={item.csp == CurrentSelection?.csp && 'active' || ''}
                    onClick={()=>{
                        if(CurrentSelection?.csp != item.csp){
                            handlerSelect({csp:item.csp,option:undefined});
                        }
                    }}
                > 
                    <img src={getIcon(item.csp)}/>
                    {item.options &&
                        <FsAutocomplete 
                            sx={{
                                '& .MuiAutocomplete-endAdornment':{
                                    top:'16px !important' 
                                }
                            }}
                            autoComplete={false}
                            multiple={false}
                            disableClearable={true}
                            options={item.options}
                            value={item.csp == CurrentSelection?.csp ? CurrentSelection?.option : item.options[0]}
                            className={`dropdown ${item.csp != CurrentSelection?.csp && 'disabled'}`} 
                            onChange={(event:any,value:any)=>{
                                
                                handlerSelect({csp:item.csp,option:value});
                            }}
                        />
                    }
                </FsButton>       
                
            ))}
        </Box>
    )
}

 


export default CloudTypeSelector;